import React, { Component, useEffect, useState } from 'react';
import { MDBDataTable, MDBPageItem, MDBPageNav, MDBPagination } from 'mdbreact';
import { Row, Col, Card, CardBody, Container, Spinner, Button } from 'reactstrap';
import ShowMoreText from 'react-show-more-text';
import useGet from '../../../../helpers/hooks/useGet';
import dayjs from 'dayjs';
import ReactAudioPlayer from 'react-audio-player';
import useDelete from '../../../../helpers/hooks/useDelete';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
const columns = [
  {
    label: 'Post',
    field: 'post',
    sort: 'disabled',
    width: 200,
  },
  {
    label: 'Farmer',
    field: 'farmer',
    sort: 'asc',
    width: 270,
  },

  {
    label: 'Likes',
    field: 'likes',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Flags',
    field: 'flags',
    sort: 'asc',
    width: 150,
  },
  {
    label: 'Created At',
    field: 'createdAt',
    sort: 'asc',
    width: 150,
  },
  {
    label: 'Actions',
    field: 'actions',
    sort: 'disabled',
    width: 100,
  },
];
const KisanPosts = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Adjust as needed
  const pagesAmount = 250; // Setting pages amount to 100

  const [postsError, setError] = useState();
  const [posts, setData] = useState();
  const [postsLoading, setLoading] = useState(false);

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const handleNext = () => {
    if (currentPage < pagesAmount) setCurrentPage(currentPage + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const call = async (offset) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_API_URL
        }/${`/baithak-posts-admin?filter[order]=createdAt DESC&filter[include][0][relation]=farmer&filter[limit]=${itemsPerPage}&filter[offset]=${offset}`}`
      );
      const result = await response.json();
      if (response.ok) {
        setData(result);
      } else {
        setError(result);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentPage === 1) {
      call(currentPage - 1);
    } else {
      call((currentPage - 1) * 10);
    }
  }, [currentPage]);
  //   const [posts, postsError, postsLoading, fetchPosts] = useGet(
  //     `/baithak-posts-admin?filter[order]=createdAt DESC&filter[include][0][relation]=farmer&filter[limit]=${itemsPerPage}&filter[offset]=${
  //       currentPage - 1
  //     }`,
  //     true
  //   );
  const [deletePost, data, error, loading] = useDelete();

  //   // Calculate the indices for slicing the data array
  //   const indexOfLastItem = currentPage * itemsPerPage;
  //   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  //   const currentItems = posts ? posts.slice(indexOfFirstItem, indexOfLastItem) : [];

  const handleDeletePost = (post) => {
    if (window.confirm('Are you sure want to delete?')) {
      deletePost(`/baithak-posts/${post.id}`).then((e) => call((currentPage - 1) * 10));
    }
  };

  // Create pagination range
  const pageNumbers = [];
  for (let i = 1; i <= pagesAmount; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    if (
      number === 1 ||
      number === pagesAmount ||
      (number >= currentPage - 1 && number <= currentPage + 1)
    ) {
      return (
        <MDBPageItem active={number === currentPage} key={number}>
          <MDBPageNav onClick={() => handlePageClick(number)} className="page-link-custom">
            {number}
          </MDBPageNav>
        </MDBPageItem>
      );
    } else if (number === currentPage - 2 || number === currentPage + 2) {
      return (
        <MDBPageItem key={number}>
          <MDBPageNav className="page-link-custom">...</MDBPageNav>
        </MDBPageItem>
      );
    }
    return null;
  });

  return (
    <React.Fragment>
      <Row>
        {postsLoading ? (
          <div className="text-center w-100">
            <Spinner className="mr-2" color="primary" />
          </div>
        ) : (
          <Col xs={12}>
            <h4 className="card-title">Kisaan Posts</h4>
            <p className="card-title-desc">
              Posts by Farmers. You can filter/sort posts by clicking on the column name.
            </p>

            <MDBDataTable
              responsive
              bordered
              searching={false}
              paging={false}
              data={{
                columns,
                rows: posts?.map((x) => ({
                  farmer: x?.farmer?.name,
                  likes: x?.likes?.length,
                  flags: x?.flags?.length,
                  createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
                  actions: (
                    <div>
                      <Button color="danger" size="sm" onClick={() => handleDeletePost(x)}>
                        Delete
                      </Button>
                      ,
                      <Link to={`/post-details/${x.id}`}>
                        <Button color="primary" size="sm">
                          View
                        </Button>
                      </Link>
                    </div>
                  ),
                  post: !x.media ? (
                    <span className="w-25 d-block">
                      <ShowMoreText
                        /* Default options */
                        lines={2}
                        more="Show more"
                        less="Show less"
                        className="content-css"
                        anchorClass="my-anchor-css-class"
                        // onClick={this.executeOnClick}
                        expanded={false}
                        width={280}
                      >
                        {x.post}
                      </ShowMoreText>
                    </span>
                  ) : x.media[0]?.type === 'AUDIO' ? (
                    <ReactAudioPlayer
                      src={x.media[0]?.url}
                      autoPlay={false}
                      controls
                      preload="auto"
                    />
                  ) : x.media[0]?.type === 'IMAGE' ? (
                    <img src={x.media[0].url} className="avatar-md" />
                  ) : (
                    <video controls="" width="233" height="233" autoplay={false} name="media">
                      <source src={x.media[0].url} type="video/mp4" />
                    </video>
                  ),
                })),
              }}
            />
            <MDBPagination className="mb-5 justify-content-center">
              <MDBPageItem disabled={currentPage === 1}>
                <MDBPageNav onClick={handlePrev} className="page-link-custom">
                  &laquo;
                </MDBPageNav>
              </MDBPageItem>
              {renderPageNumbers}
              <MDBPageItem disabled={currentPage === pagesAmount}>
                <MDBPageNav onClick={handleNext} className="page-link-custom">
                  &raquo;
                </MDBPageNav>
              </MDBPageItem>
            </MDBPagination>
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

export default KisanPosts;
